import { Component, EventEmitter, ViewChild, Input, Output, ElementRef } from "@angular/core";
import { SharedService } from "../../services/shared.service";
import * as _ from 'lodash';
import { Helper } from "../../utils/helper";
import { ToastrService } from "ngx-toastr";
import { catchError, tap } from "rxjs/operators";
import { AppConstant } from "../../constants/app.constant";
import * as XLSX from 'xlsx';
import { EMPTY } from "rxjs";

@Component({
  selector: 'app-file-upload',
  styles: [`
   input[type="file"]{
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    padding: .375rem .75rem;
    }
   }
  `],
  template: `<input type="file" [(ngModel)]="myFileValue" id="fileUploader" (change)="uplaod($event)" > <span *ngIf="loading">Loading ...</span>`
})
export class UploadFileComponent {
  @Input() FILE_FORMAT = [];
  @Input() myFileValue = "";
  @Input() UPLOAD_MODULE: string = "";
  @Output("uploadedPath") uploadedPath: EventEmitter<any> = new EventEmitter();
  @Output("alertMessage") alertMessage: EventEmitter<any> = new EventEmitter();
  @Input() limited: number = null;

  exceResult = [];
  loading: boolean = false;

  constructor(
    private toast: ToastrService,
    private sharedService: SharedService) { }

  uplaod(event) {
    if (Helper.isEmpty(this.UPLOAD_MODULE) || this.UPLOAD_MODULE == null) {
      return this.toast.error("Module is invalid");
    }

    const formData = new FormData();
    let fileName = null;
    let fileaType = null;

    let base46 = "";
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      fileName = file.name;
      let ftp = _.split(file.type, "/");
      fileaType = ftp[1];

      formData.append("fileData", file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const str = reader.result;

        const img = _.split(str, ",");
        base46 = img[1];
        let o = {
          fileName: fileName,
          uploadType: this.UPLOAD_MODULE,
          fileFormat: Helper.getFileExtention(fileName),
          fileData: base46
        };

        const excelTypes = ['xlsx', 'xls', 'csv'];
        if (excelTypes.indexOf(Helper.getFileExtention(fileName)) !== -1 && this.limited != null) {

          if (Helper.getFileExtention(fileName) == "csv") {
            reader.onload = ((e) => {
              const storeData: any = reader.result;
              let lines = storeData.split("\n");

              if (lines.length - 1 > this.limited) {
                this.clear()
                return this.toast.error(`Cannot upload more then ${this.limited} consignments`);
              } else {
                this.uploadFile(o);
              }
            });
            reader.readAsText(file);

          } else {
            reader.onload = ((e) => {
              const storeData: any = reader.result;
              const workbook = XLSX.read(storeData, { type: 'buffer' });
              workbook.SheetNames.forEach((sheet) => {
                this.exceResult = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
                if (this.exceResult.length + 1 > this.limited) {
                  this.clear()
                  return this.toast.error(`Cannot upload more then ${this.limited} consignments`);
                } else {
                  this.uploadFile(o)
                }
              });
            });
            reader.readAsArrayBuffer(file);
          }
        }
        else {
          this.uploadFile(o);
        }
      }
    }
  }

  uploadFile(o) {
    this.loading = true;
    this.sharedService.post_podImg(o)
      .pipe(
        tap(() => this.loading = false),
        tap((res: any) => {
          this.uploadedPath.emit(res.result),
            this.alertResult(true)
        }),
        catchError(() => (
          this.loading = false,
          this.myFileValue = "",
          this.alertResult(false),
          EMPTY
        ))
      )
      .subscribe();
  }
  clear() {
    this.myFileValue = ""
  }

  alertResult(isSuccess: boolean = false) {
    this.alertMessage.emit(isSuccess);
  }
}
